// extracted by mini-css-extract-plugin
module.exports = {"container":"cd86","errorIcon":"_880f"};